

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { PermissionFormComponent } from './permission-form/permission-form.component';
import { PermissionComponent } from './permission.component';
import { PermissionRoutes } from './permission.routing';

export function declaration() {
    return [PermissionComponent, PermissionFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class PermissionModule {
}

@NgModule({
    imports: [PermissionModule, PermissionRoutes],
    exports: [PermissionModule]
})
export class PermissionWithRouteModule {
}
